module.exports = __webpack_public_path__ + "static/media/placeholder-image.32fc25f7.png";